import { render, staticRenderFns } from "./HeroBenefits.vue?vue&type=template&id=095c5749&scoped=true"
import script from "./HeroBenefits.vue?vue&type=script&lang=js"
export * from "./HeroBenefits.vue?vue&type=script&lang=js"
import style0 from "./HeroBenefits.vue?vue&type=style&index=0&id=095c5749&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095c5749",
  null
  
)

export default component.exports